exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-order-js": () => import("./../../../src/pages/order.js" /* webpackChunkName: "component---src-pages-order-js" */),
  "component---src-pages-payment-details-jsx": () => import("./../../../src/pages/payment/details.jsx" /* webpackChunkName: "component---src-pages-payment-details-jsx" */)
}

